import { FC } from 'react';

interface Tab {
  key: string;
  label: string;
  icon: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab?: string;
  onTabChange?: (key: string) => void;
  textColor?: string;
  textSize?: string;
  hoverBorderColor?: string;
  iconSize?: string;
}

const Tabs: FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  textColor = 'text-neutral-500',
  textSize = 'text-sm',
  hoverBorderColor = 'border-neutral-400',
  iconSize = ''
}) => {
  const handleTabClick = (key: string) => {
    if (onTabChange) onTabChange(key);
  };

  return (
    <div className="flex border-b border-neutral-200 mb-6 gap-x-2">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`px-3 py-1 flex items-center gap-2 transition-all ${textSize} ${
            activeTab === tab.key
              ? 'border-b border-secondary-200 text-secondary-200 font-bold'
              : `${textColor} hover:border-b ${hoverBorderColor}`
          }`}
          onClick={() => handleTabClick(tab.key)}
        >
          <i
            className={`${tab.icon} ${iconSize} ${
              activeTab === tab.key ? 'text-secondary-200' : textColor
            }`}
          ></i>
          <span className="relative -top-[2px]">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default Tabs;
